import { render, staticRenderFns } from "./class-detail.vue?vue&type=template&id=f84a3556&scoped=true"
import script from "./class-detail.vue?vue&type=script&lang=js"
export * from "./class-detail.vue?vue&type=script&lang=js"
import style0 from "./class-detail.vue?vue&type=style&index=0&id=f84a3556&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84a3556",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f84a3556')) {
      api.createRecord('f84a3556', component.options)
    } else {
      api.reload('f84a3556', component.options)
    }
    module.hot.accept("./class-detail.vue?vue&type=template&id=f84a3556&scoped=true", function () {
      api.rerender('f84a3556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/class-detail.vue"
export default component.exports